<template>
	<div
		class="p-6 transition-all duration-500 border shadow-xl sm:p-8 lg:p-10 sm:shadow-2xl bg-white/90 backdrop-blur-md rounded-2xl sm:rounded-3xl border-white/40 hover:shadow-blue-500/10 animate-fade-in-up"
	>
		<div class="mb-6 text-center sm:mb-8">
			<h2 class="mb-3 text-2xl font-bold sm:text-3xl text-slate-900">
				Enter Commercial Vehicle Value
			</h2>
			<p class="max-w-2xl mx-auto text-base sm:text-lg text-slate-600">
				Please provide the estimated market value of your commercial
				vehicle
			</p>
		</div>
		<div class="max-w-md mx-auto">
			<div class="mb-6">
				<label
					for="vehicleValue"
					class="block mb-2 text-sm font-medium text-gray-700 sm:text-base"
					>Estimated Market Value (KES):</label
				>
				<input
					type="number"
					id="vehicleValue"
					v-model.number="localVehicleValue"
					min="0"
					placeholder="e.g., 5,000,000"
					class="w-full px-4 py-3 text-base leading-tight text-gray-800 transition-colors duration-200 border-2 border-gray-300 rounded-lg shadow-sm sm:px-4 sm:py-3 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
				/>
			</div>
			<div
				class="flex flex-col-reverse justify-between gap-4 mt-6 sm:flex-row sm:mt-8"
			>
				<button
					@click="previous"
					class="w-full px-6 py-3 text-base font-semibold text-blue-600 transition-colors duration-300 border-2 border-blue-600 rounded-full sm:w-auto sm:text-lg hover:bg-blue-50"
				>
					Back
				</button>
				<button
					@click="getQuotation"
					:disabled="!localVehicleValue || localVehicleValue <= 0"
					:class="[
						'w-full sm:w-auto px-6 py-3 text-base sm:text-lg rounded-full text-white font-semibold shadow-lg transition-colors duration-300',
						localVehicleValue && localVehicleValue > 0
							? 'bg-blue-600 hover:bg-blue-700'
							: 'bg-gray-400 cursor-not-allowed',
					]"
				>
					Get Quotation
				</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'CommercialVehicleValuation',
	data() {
		return {
			localVehicleValue: null,
		};
	},
	methods: {
		getQuotation() {
			if (this.localVehicleValue && this.localVehicleValue > 0) {
				this.$emit('next', { vehicleValue: this.localVehicleValue });
			}
		},
		previous() {
			this.$emit('previous');
		},
	},
};
</script>

<style scoped>
/* Scoped styles for this component */
</style>
